// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"05d1037d","455":"940002b6","977":"86f2e08d"}[chunkId] + ".chunk.js";
};